// loginSlice.js
import { createSlice } from '@reduxjs/toolkit';

const defaultUser =  {
  UserId: null,
  UserName: null,
  MobileNo: null,
  Email: null,
}

const initialState = {
    user: defaultUser,
    isLoggedIn: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action) => {
      state.user = action.payload;
      state.isLoggedIn = true;
    },
    logout: (state) => {
      state.user = defaultUser;
      state.isLoggedIn = false;
    }
  },
});

export const { login, logout } = userSlice.actions;

export const selectUser = (state) => state.user.user;

export default userSlice.reducer;